import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "hooks/redux";
import {
    addTickerToGroup,
    applyGroup,
    applyTicker,
    copyGroup,
    copyTicker,
    deleteGroup,
    deleteTickerFromGroup,
    getGroups,
    getTickersByGroup,
    removeTickerFromGroup,
} from "store/reducers/GroupsSlice";
import {
    changeTickerBlockStatus,
    getNativeSPData,
    getTickerSettings,
    resetTickerSettings,
    setSelectedGroup,
    setSelectedTicker,
    updateTickerSettings,
    resetTicker,
    getSPData,
    hasChangesSelector,
} from "store/reducers/SettingsSlice";
import NewGroupModal from "components/NewGroupModal/NewGroupModal";
import AddTickerModal from "components/AddTickerModal/AddTickerModal";
import {
    CustomArrowExpand,
    CustomCheckboxTickIcon,
    CustomLayeredSquaresIcon,
    CustomPlusCircled,
    CustomSquareMinusIcon,
    ModalContentWrapper,
    SelectDiv,
    TickerItemDiv,
    TickerName,
    TickersSelectWrapper,
    TickersTitle,
    TitleText,
    TopElementsDiv,
} from "./savedSettingsBlockStyles";
import { SearchInput } from "components/Inputs/inputsStyles";
import AreYouSureModal from "components/AreYouSureModal/AreYouSureModal";
import CombineLogsModal from "components/CombineLogsModal/CombineLogsModal";
import { getLogsStatus, setLogsTickerName } from "store/reducers/LogsSlice";
import copyName from "utils/copyName/copyName";
import Loader from "components/Loader/Loader";
import WarningEditSessionModal from "components/SettingsModals/WarningEditSessionModal/WarningEditSessionModal";
import ExitEditSessionModal from "components/SettingsModals/ExitEditSessionModal/ExitEditSessionModal";
import errorNotification from "utils/Notifications/Error";
import TPH from "utils/trade-params-handler";
import { pathname } from "store/reducers/ActionCreators";
import Cookies from "js-cookie";
import TradeParamsHandler from "utils/trade-params-handler";
import { log } from 'console';

export const groups_list = ({
    data,
}: {
    data: {
        name: string;
        id: number;
    }[];
}) => {
    const output = [];
    const default_group = data.find((x) => x.name === "default");

    if (!default_group) {
        return [];
    }

    for (const item of data) {
        if (!item || item?.name === "default") {
            continue;
        }
        output.push(item);
    }
    return [
        default_group,
        ...output.sort((a, b) => a.name.localeCompare(b.name)),
    ];
};

export const TickerItem = ({
    // groupName,
    name,
    onClick,
    // isTicker = false,
    isCurrentGroup = false,
    isSelected,
    onCheckboxClick,
    onDeleteClick,
    onCopyClick,
}: // onSaveLogsClick
any) => (
    <TickerItemDiv id={`ticker-item-${name}`} isSelected={isSelected}>
        <TickerName title={name} onClick={onClick}>
            {name}
        </TickerName>
        {/*{isTicker && <CustomArrowsShrinkIcon onClick={onSaveLogsClick}/>}*/}
        {<CustomCheckboxTickIcon onClick={onCheckboxClick} />}
        <CustomLayeredSquaresIcon onClick={onCopyClick} />
        {!isCurrentGroup && <CustomSquareMinusIcon onClick={onDeleteClick} />}
    </TickerItemDiv>
);

const FIRST_ALERT_DELAY: number = 540_000; // 9 min
const SECOND_ALERT_DELAY: number = 60_000; // 1 min

const SavedSettingsBlock = () => {
    const { groups, activeGroupTickers, groupsLoading, tickersLoading } =
        useAppSelector((state) => state.groups);
    const hasSettingsChanges = useAppSelector(hasChangesSelector);
    const {
        activeGroup,
        isChanged,
        activeTicker,
        isNewTickerAdding,
        error,
        MDPSelectedItem,
        saved_settings,
        saved_CP_settings,
        savedSettings,
    } = useAppSelector((state) => state.settings);
    const { name: groupName } = activeGroup;
    const dispatch = useDispatch();
    // const [pickedGroupId, setPickedGroupId] = useState("default")
    // const [pickedTickerName, setPickedTickerName] = useState("Название тикера")
    const [processingGroupName, setProcessingGroupName] = useState("");
    const [processingGroupId, setProcessingGroupId] = useState(-1);
    const [processingTickerName, setProcessingTickerName] = useState("");
    const [areYouSureMessage, setAreYouSureMessage] = useState<
        undefined | string
    >(undefined);
    const [areYouSureType, setAreYouSureType] = useState("");

    const [newGroupModalOpened, setNewGroupModalOpened] = useState(false);
    const [addTickerModalOpened, setAddTickerModalOpened] = useState(false);
    const [isAreYouSureModalOpen, setIsAreYouSureModalOpen] = useState(false);
    const [combineLogsModalOpen, setCombineLogsModalOpen] = useState(false);
    const [isGroupsExpanded, setIsGroupsExpanded] = useState(true);

    const [searchGroupString, setSearchGroupString] = useState("");
    const [searchTickerString, setSearchTickerString] = useState("");

    const [applicableGroup, setApplicableGroup] = useState("");
    const [applicableTicker, setApplicableTicker] = useState("");

    const [isWarningEditSessionOpen, setIsWarningEditSessionOpen] =
        useState(false);
    const [isExitEditSessionOpen, setIsExitEditSessionOpen] = useState(false);
    const firstTimerRef = useRef<number | undefined>(undefined);
    const secondTimerRef = useRef<number | undefined>(undefined);

    const unblockTickerOnLeave = (body: any) => {
        fetch(`${pathname}api/unblock`, {
            keepalive: true,
            method: "POST",
            headers: {
                Authorization: `Bearer ${Cookies.get("access")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
    };

    const startTimer = () => {
        firstTimerRef.current = +setTimeout(() => {
            setIsWarningEditSessionOpen(true);

            secondTimerRef.current = +setTimeout(() => {
                setIsWarningEditSessionOpen(false);
                localStorage.setItem("autoExitFromEditSession", "yes");
                window.location.reload();
            }, SECOND_ALERT_DELAY);
        }, FIRST_ALERT_DELAY);
    };

    useEffect(() => {
        if (localStorage.getItem("autoExitFromEditSession")) {
            setIsExitEditSessionOpen(true);
            localStorage.removeItem("autoExitFromEditSession");
        }
    }, []);

    useEffect(() => {
        if (processingGroupName) {
            document.addEventListener("mousemove", handleMouseMoveEvent);
        }
        return () => {
            clearTimeout(firstTimerRef.current);
            clearTimeout(secondTimerRef.current);
            document.removeEventListener("mousemove", handleMouseMoveEvent);
        };
    }, [processingGroupName]);

    useEffect(() => {
        dispatch(getGroups());
    }, []);

    useEffect(() => {
        if (groups?.length === 0 || !groups) return;
        // const [defaultGroup] = groups
        // const {name, id} = defaultGroup
        // dispatch(setSelectedGroup({name, id}))
        // dispatch(getTickersByGroup(name))
    }, [groups]);

    useEffect(() => {
        function innerFunc() {
            const clouserName = activeTicker.name;
            const clouserError = error;

            const requestBody = {
                blockIt: false,
                group_name: activeGroup.name,
                ticker_name: clouserName,
            };

            if (clouserName === "Название тикера" || clouserError !== null) {
                return;
            } else {
                unblockTickerOnLeave(requestBody);
            }
        }

        window.addEventListener("unload", innerFunc);

        return () => {
            window.removeEventListener("unload", innerFunc);
        };
    }, [activeTicker.name, error]);

    const onWarningModalClose = () => {
        setIsWarningEditSessionOpen(false);
        clearTimeout(secondTimerRef.current);
        handleMouseMoveEvent(); // in case when user click on button without moving a mouse
    };

    const onExitModalClose = () => {
        localStorage.removeItem("autoExitFromEditSession");
        setIsExitEditSessionOpen(false);
    };

    const handleMouseMoveEvent = () => {
        // we are disposing previous timeout and immediately creating a new one
        // eventually, we'll have only one timer left
        clearTimeout(firstTimerRef.current);

        startTimer();
    };

    const handleApplyGroupClick = (groupName: string) => {
        setApplicableGroup(groupName);
        setIsAreYouSureModalOpen(true);
        setAreYouSureMessage(
            'Тикеры данной группы заменят тикеры в группе "Текущая"'
        );
        setAreYouSureType("applyGroup");
    };

    const handleDeleteGroupClick =
        (name: string, type: "group" | "ticker") => () => {
            setIsAreYouSureModalOpen(true);
            if (type === "group") {
                setProcessingGroupName(name);
                setAreYouSureMessage("Группа будет удалена");
                setAreYouSureType("deleteGroup");
            } else if (type === "ticker") {
                setProcessingTickerName(name);
                setAreYouSureMessage("Тикер будет удален из текущей группы");
                setAreYouSureType("deleteTicker");
            }
        };

    const handleCopyClick = (name: string, type: "group" | "ticker") => () => {
        setIsAreYouSureModalOpen(true);
        if (type === "group") {
            setProcessingGroupName(name);
            setAreYouSureMessage(`Будет создана копия группы ${name}`);
            setAreYouSureType("copyGroup");
        } else if (type === "ticker") {
            setProcessingTickerName(name);
            setAreYouSureMessage(`Будет создана копия тикера ${name}`);
            setAreYouSureType("copyTicker");
        }
    };

    const handleApplyTickerClick = (tickerName: string) => {
        setApplicableTicker(tickerName);
        setIsAreYouSureModalOpen(true);
        setAreYouSureMessage('Данный тикер будет включен в группу "Текущая"');
        setAreYouSureType("applyTicker");
    };

    const handleSaveLogsTickerClick = (tickerName: string) => {
        setCombineLogsModalOpen(true);
        dispatch(setLogsTickerName(tickerName));
    };

    const handleGroupClick = (name: string, id: number) => {
        // setPickedGroupId(() => name)
        console.log("ERROR", error);
        if (isNewTickerAdding) {
            setIsAreYouSureModalOpen(true);
            setAreYouSureMessage(
                "Осуществить переход в другую группу? Все текущие изменения будут потеряны"
            );
            setAreYouSureType("changeGroup");
            setProcessingGroupName(name);
            setProcessingGroupId(id);
        } else {
            if (activeTicker.name !== "Название тикера" && error === null) {
                dispatch(
                    changeTickerBlockStatus({
                        blockIt: false,
                        group: activeGroup.name,
                        ticker: activeTicker.name,
                    })
                );
            }
            groupChangeApplyFunc(name, id);
        }
    };

    const stateHasChanges = () => {
        const check = TPH.stateHasChanges({
            saved_settings,
            affiliation: {
                ticker_name: activeTicker.name,
                group_name: activeGroup?.name,
                exchange_name: MDPSelectedItem?.SPname,
            },
        });
        return isChanged || check;
    };

    const handleTickerClick = (tickerName: string) => {
        if (tickerName === activeTicker.name) {
            //isChanged || isNewTickerAdding
        } else if (isNewTickerAdding || hasSettingsChanges) {
            setIsAreYouSureModalOpen(true);
            setAreYouSureMessage(
                "Осуществить переход на другой тикер? Все текущие изменения будут потеряны"
            );
            setAreYouSureType("changeTicker");
            setProcessingTickerName(tickerName);
        } else {
            if (activeTicker.name !== "Название тикера" && error === null) {
                dispatch(
                    changeTickerBlockStatus({
                        blockIt: false,
                        group: activeGroup.name,
                        ticker: activeTicker.name,
                    })
                ); // разблокировать тикер с которого мы ушли
            }
            tickerApplyFunc(tickerName);
        }
    };

    const tickerApplyFunc = (tickerName: string) => {
        // setPickedTickerName(tickerName)
        if (groupName === "default") {
            dispatch(getLogsStatus(tickerName));
        }
        dispatch(setSelectedTicker({ name: tickerName }));
        dispatch(getTickerSettings());
        dispatch(setLogsTickerName(tickerName));
        dispatch(getNativeSPData({ search: tickerName }));
    };

    const groupChangeApplyFunc = (name, id) => {   
             
        // setPickedTickerName(tickerName)
        setProcessingGroupName(name);
        setProcessingGroupId(id);
        dispatch(setSelectedGroup({ name, id }));
        dispatch(getTickersByGroup(name));
        dispatch(resetTickerSettings());
    };

    const handleSearchGroup = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchGroupString(e.target.value);
    };

    const handleSearchTicker = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchTickerString(e.target.value);
    };
    const handleExpandClick = () => {
        setIsGroupsExpanded((prevState) => !prevState);
    };

    const handleAddTickerParamsButtonClick = () => {
        if (activeGroup.name === "Группа") {
            errorNotification("Выберите группу, чтобы добавить тикер");
        } else if (!isChanged && !isNewTickerAdding) {
            dispatch(getTickersByGroup(activeGroup.name));
            setAddTickerModalOpened(true);
        } else {
            setAreYouSureType("openAddTickerModal");
            setIsAreYouSureModalOpen(true);
            setAreYouSureMessage(
                "Вызвать окно добавления нового тикера? Все текущие изменения будут потеряны"
            );
        }
    };

    const handleAreYouSureApplyFunc = (type: string) => {
        switch (type) {
            default:
                return;
            case "reset":
                return () => {};
            case "applyGroup":
                return () => {
                    dispatch(applyGroup(applicableGroup));
                    setIsAreYouSureModalOpen(false);
                };
            case "copyGroup":
                return () => {
                    setIsAreYouSureModalOpen(false);
                    const groupArr = groups.map((group) => group.name);
                    const name = copyName(processingGroupName, groupArr);
                    dispatch(
                        copyGroup({
                            groupCopyName: name,
                            groupName: processingGroupName,
                        })
                    );
                };
            case "deleteGroup":
                return () => {
                    setIsAreYouSureModalOpen(false);
                    dispatch(deleteGroup(processingGroupName));
                };
            case "applyTicker":
                return () => {
                    const _saved_settings: any = {
                        CP: savedSettings.CP,
                        SP: savedSettings.SP,
                    };
                    const MDP = [];
                    for (const key of Object.keys(savedSettings.MDP)) {
                        let part = savedSettings.MDP[key];
                        if (part.length === 1) {
                            part = [...part[0]];
                        }
                        MDP.push([...part]);
                    }
                    _saved_settings.MDP = MDP;

                    const valid = TradeParamsHandler.validate(saved_settings);

                    if (valid.length) {
                        for (const error of valid) {
                            const { exchange_name, field, invalid_value } =
                                error;
                            const message = `
                            Ошибка валидации: ${exchange_name}
                            Параметр: ${field}
                            Значение: ${invalid_value}
                            `;
                            Error(message);
                            setIsAreYouSureModalOpen(false);
                            setAreYouSureType("");
                        }
                        setIsAreYouSureModalOpen(false);
                        setAreYouSureType("");
                        return;
                    }
                    let out;
                    try {
                        out = TradeParamsHandler.buildRequestBody(
                            "ticker_apply",
                            {
                                settings: saved_settings,
                                saved_settings: _saved_settings,
                                group_name: activeGroup.name,
                                ticker_name: activeTicker.name,
                                saved_CP_settings: saved_CP_settings,
                            }
                        );
                    } catch (error) {
                        console.error(error);
                        return Error(`Вот эту ошибку ищем: ${error.message}`);
                    }
                    //@ts-ignore
                    let request_body: TradeParamsRequest = {};
                    let has_error = false;
                    for (const body of out) {
                        const check = TradeParamsHandler.checkSP(body.SP);
                        if (check.error) {
                            has_error = true;
                            Error(check.error);
                        }

                        const check_mdp = TradeParamsHandler.validateMDP(
                            body.MDP[1]
                        );

                        if (typeof check_mdp === "object" && check_mdp.error) {
                            Error(check_mdp.error);
                            setIsAreYouSureModalOpen(false);
                            setAreYouSureType("");
                            return;
                        }

                        if (!Object.keys(request_body).length) {
                            request_body = JSON.parse(JSON.stringify(body));
                            continue;
                        }
                        const MDP = body.MDP[1].slice();
                        const SP = body.SP[1].slice();
                        request_body.MDP.push(MDP);
                        request_body.SP.push(SP);
                    }

                    if (!has_error) {
                        dispatch(updateTickerSettings({ body: request_body }));
                    }
                    setIsAreYouSureModalOpen(false);
                    setAreYouSureType("");
                };
            case "copyTicker":
                return () => {
                    dispatch(copyTicker(processingTickerName));
                    setIsAreYouSureModalOpen(false);
                    const nameTicker = copyName(
                        processingTickerName,
                        activeGroupTickers.map((obj) => obj.name)
                    );
                    dispatch(
                        addTickerToGroup({ name: nameTicker, isNew: true })
                    );
                };
            case "deleteTicker":
                return () => {
                    setIsAreYouSureModalOpen(false);
                    dispatch(deleteTickerFromGroup(processingTickerName));
                    dispatch(
                        resetTicker({ ticker_name: processingTickerName })
                    );
                };
            case "saveLogsTicker":
                return () => {
                    setIsAreYouSureModalOpen(false);
                };
            case "changeTicker":
                return () => {
                    dispatch(getTickersByGroup(activeGroup.name));
                    tickerApplyFunc(processingTickerName);
                    setIsAreYouSureModalOpen(false);
                    dispatch(
                        changeTickerBlockStatus({
                            blockIt: false,
                            group: activeGroup.name,
                            ticker: activeTicker.name,
                        })
                    ); // разблокировать тикер с которого мы ушли
                };
            case "changeGroup":
                return () => {
                    groupChangeApplyFunc(
                        processingGroupName,
                        processingGroupId
                    );
                    setIsAreYouSureModalOpen(false);
                };
            case "openAddTickerModal":
                return () => {
                    dispatch(getTickersByGroup(activeGroup.name));
                    setAddTickerModalOpened(true);
                    setIsAreYouSureModalOpen(false);
                };
        }
    };

    let groupsList = groups_list({ data: groups.slice() });

    groupsList = groupsList?.map(
        ({ name }: { name: string }, index: number) => {
            let isCurrentGroup = name === "default";
            if (typeof name !== "string") {
                return <></>;
            }
            return (
                <TickerItem
                    key={name}
                    name={isCurrentGroup ? "Текущая" : name}
                    isCurrentGroup={isCurrentGroup}
                    onClick={() => handleGroupClick(name, index)}
                    isSelected={activeGroup.name === name}
                    onCheckboxClick={() => handleApplyGroupClick(name)}
                    onCopyClick={handleCopyClick(name, "group")}
                    onDeleteClick={handleDeleteGroupClick(name, "group")}
                />
            );
        }
    );

    const groupTickersList = activeGroupTickers
        ?.filter((obj) => {
            return obj.name.includes(searchTickerString);
        })
        ?.sort()
        ?.map(({ name }) => {
            const croppedName = name.split("~")[0];
            return (
                <TickerItem
                    groupName={groupName}
                    key={name}
                    name={croppedName}
                    onClick={() => {
                        handleTickerClick(croppedName);
                    }}
                    isSelected={activeTicker.name === croppedName}
                    isTicker
                    onCheckboxClick={() => handleApplyTickerClick(name)}
                    onCopyClick={handleCopyClick(croppedName, "ticker")}
                    onDeleteClick={handleDeleteGroupClick(
                        croppedName,
                        "ticker"
                    )}
                    onSaveLogsClick={() =>
                        handleSaveLogsTickerClick(croppedName)
                    }
                />
            );
        });
    // const groupTickersList =

    return (
        <>
            <ModalContentWrapper>
                <TickersSelectWrapper>
                    <TopElementsDiv>
                        <TickersTitle>
                            {isGroupsExpanded && <TitleText>Группы</TitleText>}
                            <CustomArrowExpand onClick={handleExpandClick} />
                            {isGroupsExpanded && (
                                <CustomPlusCircled
                                    onClick={() => setNewGroupModalOpened(true)}
                                />
                            )}
                        </TickersTitle>
                        {isGroupsExpanded && (
                            <SearchInput
                                onChange={handleSearchGroup}
                                type="text"
                                placeholder={"Поиск"}
                            />
                        )}
                    </TopElementsDiv>
                    <SelectDiv
                        renderThumbVertical={(props) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    backgroundColor: "#7CBE7B",
                                    borderRadius: "10px",
                                    left: "1",
                                    zIndex: 2,
                                }}
                            />
                        )}
                    >
                        {!groupsLoading &&
                            groups?.length > 0 &&
                            isGroupsExpanded &&
                            groupsList}
                        {groupsLoading && groups?.length === 0 && (
                            <Loader size="large" />
                        )}
                    </SelectDiv>
                </TickersSelectWrapper>
                <TickersSelectWrapper>
                    <TopElementsDiv>
                        <TickersTitle>
                            Тикеры
                            <CustomPlusCircled
                                onClick={handleAddTickerParamsButtonClick}
                            />
                        </TickersTitle>
                        <SearchInput
                            onChange={handleSearchTicker}
                            type="text"
                            placeholder={"Поиск"}
                        />
                    </TopElementsDiv>
                    <SelectDiv
                        id={`ticker-items-wrapper`}
                        renderThumbVertical={(props) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    backgroundColor: "#7CBE7B",
                                    borderRadius: "10px",
                                    left: "1",
                                    zIndex: 2,
                                }}
                            />
                        )}
                    >
                        {tickersLoading && <Loader size="large" />}
                        {!tickersLoading &&
                            activeGroupTickers &&
                            groupTickersList}
                    </SelectDiv>
                </TickersSelectWrapper>
            </ModalContentWrapper>
            {newGroupModalOpened && (
                <NewGroupModal
                    isOpen={newGroupModalOpened}
                    onRequestClose={() => setNewGroupModalOpened(false)}
                />
            )}
            {
                <AddTickerModal
                    isOpen={addTickerModalOpened}
                    onRequestClose={() => setAddTickerModalOpened(false)}
                />
            }
            {isAreYouSureModalOpen && (
                <AreYouSureModal
                    title={"Вы уверены?"}
                    description={areYouSureMessage}
                    isOpen={isAreYouSureModalOpen}
                    onRequestClose={() => setIsAreYouSureModalOpen(false)}
                    onApplyClick={handleAreYouSureApplyFunc(areYouSureType)}
                />
            )}
            {combineLogsModalOpen && (
                <CombineLogsModal
                    isOpen={combineLogsModalOpen}
                    onRequestClose={() => setCombineLogsModalOpen(false)}
                />
            )}
            <WarningEditSessionModal
                isOpen={isWarningEditSessionOpen}
                onRequestClose={onWarningModalClose}
            />
            <ExitEditSessionModal
                isOpen={isExitEditSessionOpen}
                onRequestClose={onExitModalClose}
            />
        </>
    );
};

export default SavedSettingsBlock;
